import ru from '@/app/langs/lang.ru.js';
import uk from '@/app/langs/lang.uk.js';

let lang = app.client && app.client.lang == 'uk' ? uk : ru;

export default lang